document.addEventListener("DOMContentLoaded", function () {
    function initSlidersForGroup(groupEl) {
      const $group = $(groupEl);
      const $main  = $group.find('.main-image-slider');
      const $thumb = $group.find('.thumbnail-slider');

      // init thumbnails first
      if ($thumb.length && !$thumb.hasClass('slick-initialized')) {
        $thumb.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: $main,        // keep same style as your reference
          focusOnSelect: true,
          arrows: false,
          centerMode: false
        });
      }

      // init main after thumbs
      if ($main.length && !$main.hasClass('slick-initialized')) {
        $main.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: $thumb,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev" aria-label="Previous product image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next" aria-label="Next product image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg></button>',
  fade: false,
  dots: true,
  swipe: false,      // disable swipe
  touchMove: false,  // disable drag
  adaptiveHeight: false
});
      } else {
        // refresh layout if already initialized
        if ($main.hasClass('slick-initialized'))  $main.slick('setPosition');
        if ($thumb.hasClass('slick-initialized')) $thumb.slick('setPosition');
      }
    }

    function showImageGroup(input) {
      const gallery = document.querySelector('#all-product-images');
      if (!gallery) return;
      const groups = Array.from(gallery.querySelectorAll('.image-group-by-alt'));
      const selectedAlt = input?.value?.trim().toLowerCase();
      const shared = gallery.hasAttribute('data-shared-gallery');
      // Keep a usable gallery even when an image has no matching colour alt.
      const target = (shared ? groups[0] : groups.find(group =>
        group.dataset.alt?.trim().toLowerCase() === selectedAlt
      )) || groups.find(group => !group.classList.contains('hide')) || groups[0];
      if (!target) return;
      groups.forEach(group => group.classList.toggle('hide', group !== target));
      initSlidersForGroup(target);

      if (shared) {
        const main = $(target).find('.main-image-slider');
        const slides = Array.from(target.querySelectorAll('.main-slide:not(.slick-cloned)'));
        const mediaId = input?.dataset.galleryMediaId;
        let index = mediaId ? slides.findIndex(slide => slide.dataset.mediaId === mediaId) : -1;
        if (index < 0 && selectedAlt) {
          index = slides.findIndex(slide => slide.querySelector('img')?.alt.trim().toLowerCase() === selectedAlt);
        }
        if (index >= 0) main.slick('slickGoTo', index, true);
      }
    }

    showImageGroup(document.querySelector('.color-var-image input[type="radio"]:checked'));

    // A change event covers image clicks, label clicks and keyboard selection.
    document.body.addEventListener('change', function (event) {
      if (event.target.matches('.color-var-image input[type="radio"]')) {
        showImageGroup(event.target);
      }
    });
  });

// Preserve the sticky gallery's viewport position while checkout/cart locks page scrolling.
document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('#root #main-product > .l4pr-container');
  const slider = gallery?.querySelector('#all-product-images');
  if (!gallery || !slider) return;
  const desktop = window.matchMedia('(min-width: 761px)');
  let snapshot = null;
  let locked = false;
  function remember() {
    if (locked || !desktop.matches) return;
    const rect = slider.getBoundingClientRect();
    snapshot = {top: rect.top, left: rect.left, width: rect.width, height: gallery.getBoundingClientRect().height};
  }
  function sync() {
    const bodyStyle = getComputedStyle(document.body);
    const htmlStyle = getComputedStyle(document.documentElement);
    const shouldLock = desktop.matches && (bodyStyle.overflowY === 'hidden' || bodyStyle.position === 'fixed' || htmlStyle.overflowY === 'hidden');
    if (shouldLock && !locked && snapshot) {
      for (const key of ['top', 'left', 'width', 'height']) gallery.style.setProperty('--dw-gallery-lock-' + key, snapshot[key] + 'px');
      gallery.classList.add('dw-gallery-scroll-locked');
      locked = true;
    } else if (!shouldLock && locked) {
      gallery.classList.remove('dw-gallery-scroll-locked');
      for (const key of ['top', 'left', 'width', 'height']) gallery.style.removeProperty('--dw-gallery-lock-' + key);
      locked = false;
      remember();
    } else if (!locked) remember();
  }
  document.addEventListener('pointerdown', remember, true);
  document.addEventListener('click', remember, true);
  window.addEventListener('scroll', remember, {passive: true});
  window.addEventListener('resize', sync, {passive: true});
  const observer = new MutationObserver(sync);
  for (const target of [document.body, document.documentElement]) observer.observe(target, {attributes: true, attributeFilter: ['style', 'class']});
  remember();
});
